import { Search, X, Download } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";

export const Toolbar = ({ q, setQ, from, setFrom, to, setTo, onExport }) => (
  <div data-testid="global-search-bar" className="flex flex-col md:flex-row gap-3 md:items-end bg-white border rounded-xl p-3">
    <div className="relative flex-1">
      <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
      <Input data-testid="search-input" placeholder="Search group, site name or user ID" value={q} onChange={(e) => setQ(e.target.value)} className="pl-9" />
    </div>
    <div className="flex gap-2 items-end">
      <label className="text-xs text-slate-500 space-y-1">
        <span>From</span>
        <Input data-testid="date-from-input" type="date" value={from} onChange={(e) => setFrom(e.target.value)} className="font-mono" />
      </label>
      <label className="text-xs text-slate-500 space-y-1">
        <span>To</span>
        <Input data-testid="date-to-input" type="date" value={to} onChange={(e) => setTo(e.target.value)} className="font-mono" />
      </label>
      {(from || to || q) && (
        <Button variant="ghost" size="icon" data-testid="clear-filters-btn" onClick={() => { setFrom(""); setTo(""); setQ(""); }}>
          <X className="w-4 h-4" />
        </Button>
      )}
    </div>
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" data-testid="export-menu-btn"><Download className="w-4 h-4 mr-2" />Export</Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem data-testid="export-csv-button" onClick={() => onExport("csv")}>Download CSV</DropdownMenuItem>
        <DropdownMenuItem data-testid="export-excel-btn" onClick={() => onExport("xlsx")}>Download Excel (.xlsx)</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  </div>
);
